import * as React from "react";
import { forwardRef } from "react";
const SvgSystemMaintenance = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15.248 11.585 8.903 5.172V3a2 2 0 0 0-.58-1.414l-.988-1A1.97 1.97 0 0 0 5.935 0H2.967a1.98 1.98 0 0 0-1.8 1.177A2 2 0 0 0 0 3v3c0 .529.208 1.037.579 1.414l.989 1a1.97 1.97 0 0 0 1.4.585h2.148l6.344 6.414a1.96 1.96 0 0 0 2.8 0l.99-1a2.015 2.015 0 0 0-.002-2.828M12.86 14 5.936 7H2.968l-.99-1V3l.99 1 .989 1h.989V4l-.99-1-.988-1h2.968l.989 1v3l6.924 7z" }));
const ForwardRef = forwardRef(SvgSystemMaintenance);
export { ForwardRef as ReactComponent };
